import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Sarah & Ahmed",
    location: "Dubai, UAE",
    quote: "Friendato's AI understood what we were looking for better than we did ourselves. We connected over shared values and now we're planning our future together!",
    rating: 5,
    image: "/placeholder.svg"
  },
  {
    name: "Fatima & Omar",
    location: "Abu Dhabi, UAE",
    quote: "The bot dating feature was incredible. It helped us break the ice and understand each other's personalities before we even started chatting.",
    rating: 5,
    image: "/placeholder.svg"
  },
  {
    name: "Aisha & Yusuf",
    location: "Sharjah, UAE",
    quote: "Privacy was so important to us, and Friendato delivered. We felt safe and respected throughout our journey to finding each other.",
    rating: 5,
    image: "/placeholder.svg"
  }
];

const Testimonials = () => {
  return (
    <section className="py-24 sm:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-muted/30" />
      <div className="absolute inset-0 bg-gradient-mesh opacity-20" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 stagger-children">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Star className="w-4 h-4 text-primary fill-primary" />
            <span className="text-sm font-medium text-primary">Success Stories</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
            Real Connections,{" "}
            <span className="bg-gradient-hero bg-clip-text text-transparent">
              Real Stories
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Join thousands of couples who found their perfect match through Friendato
          </p>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="glass-card p-8 rounded-3xl relative"
            >
              {/* Quote icon */}
              <div className="absolute top-6 right-6">
                <Quote className="w-8 h-8 text-primary/20" />
              </div>
              
              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-primary fill-primary" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-foreground mb-8 leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-hero flex items-center justify-center text-primary-foreground font-bold">
                  {testimonial.name.split(' ')[0][0]}
                </div>
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
